import React, { Fragment, useState, useEffect } from "react";
import "./EditPartnerModal.scss";

import { useTranslation } from "react-i18next";
import { FiEdit2, FiMinus, FiPlus } from "react-icons/fi";
import { useSelector, useDispatch } from "react-redux";

import { findPhoneData } from "../../../../helper/findPhoneData";
import { updatePartner, resetUpdatePartner } from "../../../../store/partner/partnerSlice";

import DModal from "../../../Modal/DModal/DModal";
import DInputs from "../../../Form/DInputs/DInputs";
import SelectableButton from "../../Components/SelectableButton/SelectableButton";
import DPhoneInput from "../../../Form/DPhoneInput/DPhoneInput";

const EditPartnerModal = ({ item, isOpen, isClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { updatePartnerLoading, updatePartnerResult, updatePartnerError } = useSelector(
    (state) => state.partner
  );
  const { getPhoneIndexesResult, phoneIndexValueId } = useSelector((state) => state.settings);

  const { getTrailerTypesRoadResult } = useSelector((state) => state.trailerType);
  const { getAllRoutesRoadListResult } = useSelector((state) => state.routes);

  const [partnerID, setPartnerID] = useState(item?.code || "");
  const [partnerName, setPartnerName] = useState(item?.name || "");
  const [email, setEmail] = useState(item?.email || "");
  const [phone, setPhone] = useState(item?.phone || "");
  const [showSecondaryPhone, setShowSecondaryPhone] = useState(item?.phone2 ? true : false);
  const [phone2, setPhone2] = useState(item?.phone2 || "");
  const [phone1Index, setPhone1Index] = useState(null);
  const [phone2Index, setPhone2Index] = useState(null);

  const [selectedTrailerTypes, setSelectedTrailerTypes] = useState(
    item?.trailer_types?.map((item) => item?.id) || []
  );
  const [selectedRoutes, setSelectedRoutes] = useState(
    item?.route_types?.map((item) => item?.id) || []
  );

  const submitHandler = () => {
    const data = {
      id: item.id,

      code: partnerID,
      name: partnerName,
      email: email,
      phone: phone,
      phone2: (showSecondaryPhone && phone2) || null,
      phone_index_id: phone1Index?.value?.id || null,
      phone2_index_id: (showSecondaryPhone && phone2Index?.value?.id) || null,
      trailer_types: selectedTrailerTypes,
      route_types: selectedRoutes,
    };
    dispatch(updatePartner(data));
  };

  useEffect(() => {
    if (item?.phone) {
      const phoneIndexObj = item?.phone_index_id
        ? findPhoneData(getPhoneIndexesResult, item?.phone_index_id)
        : findPhoneData(getPhoneIndexesResult, phoneIndexValueId);

      setPhone1Index({
        value: phoneIndexObj,
        label: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "15px",
                height: "15px",
                backgroundImage: `url(${phoneIndexObj?.flag})`,
                backgroundPosition: "cover",
                backgroundRepeat: "no-repeat",
                marginRight: "5px",
              }}
            ></div>
            <p>{phoneIndexObj.phone_index}</p>
          </div>
        ),
      });
    }
    const phone2IndexObj = item?.phone2_index_id
      ? findPhoneData(getPhoneIndexesResult, item?.phone2_index_id)
      : findPhoneData(getPhoneIndexesResult, phoneIndexValueId);

    setPhone2Index({
      value: phone2IndexObj,
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundImage: `url(${phone2IndexObj?.flag})`,
              backgroundPosition: "cover",
              backgroundRepeat: "no-repeat",
              marginRight: "5px",
            }}
          ></div>
          <p>{phone2IndexObj?.phone_index}</p>
        </div>
      ),
    });
  }, [getPhoneIndexesResult, item, phoneIndexValueId]);

  useEffect(() => {
    if (updatePartnerResult) {
      dispatch(resetUpdatePartner());
      isClose();
    }
  }, [dispatch, updatePartnerResult, isClose]);

  useEffect(() => {
    return () => {
      dispatch(resetUpdatePartner());
    };
  }, [dispatch]);

  return (
    <Fragment>
      <DModal
        isOpen={isOpen}
        isClose={isClose}
        title={t("tms.modals.titles.Edit Partner")}
        icon={<FiEdit2 />}
        status='success'
        onClick={() => submitHandler()}
        submitText={t("tms.modals.buttons.Save")}
        loading={updatePartnerLoading}
      >
        <div id='EditPartnerModal'>
          <div className='EditPartnerModalgroup'>
            <DInputs
              value={partnerName}
              setValue={setPartnerName}
              placeholder={t("tms.modals.placeholder.Enter partner name")}
              label={t("tms.modals.labels.Partner name")}
              required
              id='partnerNamepartner'
              error={updatePartnerError?.errors?.name?.[0] ?? null}
            />
            <DInputs
              value={partnerID}
              setValue={setPartnerID}
              placeholder={t("tms.modals.placeholder.Enter partner ID")}
              label={t("tms.modals.labels.Partner ID")}
              required
              id='partnerIDIDpartner'
              error={updatePartnerError?.errors?.code?.[0] ?? null}
            />
            <DPhoneInput
              id='PartnerPhone'
              value={phone}
              setValue={setPhone}
              indexValue={phone1Index}
              setIndexValue={setPhone1Index}
              placeholder={t("tms.modals.placeholder.Enter phone number")}
              label={t("tms.modals.labels.Phone number")}
              error={
                updatePartnerError?.errors?.phone?.[0] ||
                updatePartnerError?.errors?.phone_index_id?.[0] ||
                null
              }
              status={t("tms.modals.labels.Primary")}
            />
            {!showSecondaryPhone ? (
              <div className='showSecondaryPhoneButtonContainer'>
                <div
                  className='showSecondaryPhoneButton'
                  onClick={() => setShowSecondaryPhone(true)}
                >
                  <div className='icon'>
                    <FiPlus />
                  </div>
                  <div className='text'>{t("tms.modals.buttons.Add secondary phone number")}</div>
                </div>
              </div>
            ) : (
              <Fragment>
                <DPhoneInput
                  id='PartnerPhoneSecondary'
                  value={phone2}
                  setValue={setPhone2}
                  indexValue={phone2Index}
                  setIndexValue={setPhone2Index}
                  placeholder={t("tms.modals.placeholder.Enter phone number")}
                  label={t("tms.modals.labels.Phone number")}
                  error={
                    updatePartnerError?.errors?.phone2?.[0] ||
                    updatePartnerError?.errors?.phone2_index_id?.[0] ||
                    null
                  }
                  status={t("tms.modals.labels.Secondary")}
                />
                <div className='hideSecondaryPhoneButtonContainer'>
                  <div
                    className='hideSecondaryPhoneButton'
                    onClick={() => setShowSecondaryPhone(false)}
                  >
                    <div className='icon'>
                      <FiMinus />
                    </div>
                    <div className='text'>
                      {t("tms.modals.buttons.Remove secondary phone number")}
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
            <DInputs
              value={email}
              setValue={setEmail}
              placeholder={t("tms.modals.placeholder.Enter email")}
              label={t("tms.modals.labels.Email")}
              id='PartnerEmail'
              error={updatePartnerError?.errors?.email?.[0] ?? null}
            />
            <div className='prefferedTrailerTypesContainer'>
              <div className='prefferedTrailerTypesTitle'>
                {t("tms.modals.titles.Preffered trailer types")}
              </div>
              <div className='prefferedTrailerTypesList'>
                {getTrailerTypesRoadResult &&
                  getTrailerTypesRoadResult.map((prefferedTrilerType) => (
                    <SelectableButton
                      key={prefferedTrilerType?.id}
                      item={prefferedTrilerType}
                      selectedTypes={selectedTrailerTypes}
                      setSelectedTypes={setSelectedTrailerTypes}
                      selected={selectedTrailerTypes.includes(prefferedTrilerType?.id)}
                    />
                  ))}
              </div>
            </div>
            <div className='prefferedTrailerTypesContainer'>
              <div className='prefferedRoutesTitle'>{t("tms.modals.titles.Preffered routes")}</div>
              <div className='prefferedTrailerTypesList'>
                {getAllRoutesRoadListResult &&
                  getAllRoutesRoadListResult.map((item) => (
                    <SelectableButton
                      key={item?.id}
                      item={item}
                      selectedTypes={selectedRoutes}
                      setSelectedTypes={setSelectedRoutes}
                      selected={selectedRoutes.includes(item?.id)}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </DModal>
    </Fragment>
  );
};

export default EditPartnerModal;
